import { Modal, Button as AntButton } from "antd";
import React from "react";

// Assets
import PaymentSuccessImg from "../../assets/icons/success-icon.svg";

const ConfirmationPaymentModal = ({
    isOpen,
    onClose,
    onConfirm,
    paymentDetails,
    title = "Payment Successful!",
})=> {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }) + ' – ' + date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatDateShort = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }) + '-' + date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).replace(' ', '');
    };

    const formatDateOnly = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            width={600}
            centered
            className="confirmation-modal"
            style={{
                backgroundColor: '#F6FCFF',
                borderRadius: '40px',
            }}
            bodyStyle={{
                padding: "0px 3px",
            }}
        >
            {/* Modal content here */}
        <div className="flex items-center justify-center w-[151px] h-[150px] max-[500px]:w-[80px] max-[500px]:h-[80px] mx-auto">
            <img src={PaymentSuccessImg} alt="successImg" className="max-[500px]:w-full max-[500px]:h-full"/>
        </div>
        <h1 className="text-center mt-10 text-[#242527] font-alexandria font-semibold text-[30px] max-[500px]:text-[20px] leading-[37px] tracking-[0%]">
            Payment Processing!
        </h1>
        <p className="text-center font-poppins text-[#494949] font-medium text-[17px] max-[500px]:text-[14px] leading-[37px] tracking-[0%] text-content mt-[10px]">
            Thank you, your payment has been processing.
        </p>
        <div className="flex flex-col  w-auto h-auto mx-auto mt-[24px] rounded-[14px] shadow-[0px_4px_4px_0px_#00000012] bg-white p-6 max-[500px]:p-4">
            <h1 className="font-poppins font-semibold text-[#242527] text-lg max-[500px]:text-base mb-5"> 
                Payment Summary
            </h1>
            <div className="grid  grid-cols-2 gap-y-[5px] gap-x-[5px]">
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Tenant:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    {paymentDetails?.tenant}
                </span>
                
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Property:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    {paymentDetails?.property}
                </span>
                
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Unit:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    {paymentDetails?.unit}
                </span>
                
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Landlord:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    {paymentDetails?.landlord}
                </span>
                
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Amount Paid:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    {paymentDetails?.amount}
                </span>
                
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949]">
                    Date & Time:
                </span>
                <span className="font-poppins font-medium text-[15px] max-[500px]:text-[12px] leading-[23px] tracking-[0%] text-[#494949] text-right">
                    <span className="hidden max-[500px]:inline">
                        {formatDateShort(paymentDetails?.paymentDate)}
                    </span>
                    <span className="max-[500px]:hidden">
                        {formatDate(paymentDetails?.paymentDate)}
                    </span>
                </span>
            </div>
            <div className=" items-center justify-start w-auto h-auto max-[500px]:h-auto rounded-[3px] p-[7px] gap-[10px] mt-6"
                style={{ backgroundColor: 'rgba(71, 114, 241, 0.1)' }}
            >
                <span className="font-poppins font-medium text-[11px] max-[500px]:text-[9px] leading-[17px] tracking-[0%] p-[7px] text-center text-[#4772F1ED]">
                    Your rent is now paid up to <span className="font-semibold">{formatDateOnly(paymentDetails?.rentCoveredTo)}</span>
                </span>
            </div>
        </div>
        <div className="flex flex-col h-auto w-auto  mx-auto">
            <div className="flex items-center justify-start h-auto w-auto rounded-[3px] p-[7px] gap-[10px] mt-[15px]"
                style={{ backgroundColor: 'rgba(71, 114, 241, 0.1)' }}
            >
                <span className="font-poppins font-medium text-[11px] max-[500px]:text-[9px] leading-[17px] tracking-[0%] text-center p-[7px] text-[#4772F1ED]">
                    This payment is in the processing stage and will be confirmed shortly.
                    You will receive an email once the payment is successfully confirmed by your landlord.
                    If you do not receive an update, please try again after approximately 5 minutes.
                </span>
            </div>
        </div>
        <div className="flex justify-center mt-10 mb-0">
          <AntButton
            onClick={onConfirm}
            className="flex items-center justify-center font-poppins max-[500px]:w-[150px] max-[500px]:h-[40px]"
            style={{
              width: '195px',
              height: '46px',
              borderRadius: '3px',
              padding: '20px 40px',
              gap: '10px',
              background: 'linear-gradient(97.65deg, #60BBEE 0.33%, #0A72AD 93.35%)',
              boxShadow: '0px 10px 15px 0px #01739933',
              border: 'none',
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '100%',
              letterSpacing: '0%',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            <span style={{ 
              width: '173px', 
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} className="max-[500px]:text-[14px]">
              Return to Home page
            </span>
          </AntButton>
        </div>
        </Modal>
    )
}

export default ConfirmationPaymentModal;